import { __decorate, __metadata } from "tslib";
import { BaseTrackingEventHandler } from "../core/module/BaseTrackingEventHandler";
import { injectable, inject } from "inversify";
import { SegmentAnalyticsProvider } from "./SegmentAnalyticsProvider";
import { Logger } from "@leavy/logger";
let BaseTrackingEventSegmentHandler = class BaseTrackingEventSegmentHandler extends BaseTrackingEventHandler {
    async onTrackingEvent(event) {
        try {
            await this.segment.run(analytics => this.send(event, analytics));
        }
        catch (e) {
            this.logger.warn("Error happened while sending event to Segment", {
                event,
                error: e,
            });
        }
    }
};
__decorate([
    inject(SegmentAnalyticsProvider),
    __metadata("design:type", SegmentAnalyticsProvider)
], BaseTrackingEventSegmentHandler.prototype, "segment", void 0);
__decorate([
    inject(Logger),
    __metadata("design:type", Logger)
], BaseTrackingEventSegmentHandler.prototype, "logger", void 0);
BaseTrackingEventSegmentHandler = __decorate([
    injectable()
], BaseTrackingEventSegmentHandler);
export { BaseTrackingEventSegmentHandler };
//# sourceMappingURL=BaseTrackingEventSegmentHandler.js.map